import {tenantTimeFormat} from "../../utils/time";

//format date using tenant preferred format for date
export const dateFormat = (datetime) => {
    if (datetime) return datetime.format(tenantTimeFormat("date"))
}

// Add leading 0 if score is less than 10
export const scoreFormat = (score) => {
    if (score) return score.toString().length === 1 ? "0" + score : score;
}

// set descriptive text depending on risk level
export const risk = (riskLevel) => {
    switch (riskLevel) {
        case 'good':
            return 'Low Risk';
        case 'meh':
            return 'Moderate Risk';
        case 'bad':
            return 'High Risk';
        default:
            return '';
    }
}

// show trending direction based on current and previous score
export const trend = (successScore, previousScore) => {
    if (successScore < previousScore)
        return 'trending_down';
    if (successScore > previousScore)
        return 'trending_up'
    return 'trending_flat';
}

// trend direction text to use based on current score and previous score
export const trendDirection = (successScore, previousScore) => {
    if (successScore < previousScore)
        return 'Decreased';
    if (successScore > previousScore)
        return 'Increased'
    return 'No change';
}

// set descriptive text depending on risk level
export const riskLikelihood = (riskLevel) => {
    switch (riskLevel) {
        case 'good':
            return 'highly';
        case 'meh':
            return 'moderately';
        case 'bad':
            return 'less';
        default:
            return '';
    }
}
